module.exports = __webpack_public_path__ + "img/qualite_acaplast_02.4d03bccc.jpg";